(function () {
    'use strict';

    /*
     * Select / unselect Gift Wrapping
     */
    document.addEventListener('click', function (event) {
        var giftButton = event.target.closest('.gift-wrap-btn');

        if (!giftButton) {
            return;
        }

        event.preventDefault();
        event.stopPropagation();

        giftButton.classList.toggle('is-selected');
    });


    /*
     * Intercept the theme's Add to Cart click BEFORE
     * the locked theme JavaScript receives it.
     */
    document.addEventListener('click', function (event) {

        var addButton = event.target.closest('.js_add_to_cart_button');

        if (!addButton) {
            return;
        }

        /*
         * Only use our custom logic when Gift Wrapping
         * has actually been selected.
         *
         * If not selected, allow the normal theme
         * Add to Cart code to continue.
         */
        var giftButton = document.querySelector('.gift-wrap-btn.is-selected');

        if (!giftButton) {
            return;
        }

        /*
         * Stop the locked theme Add to Cart handler.
         */
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        if (addButton.classList.contains('gift-wrap-processing')) {
            return;
        }

        addButton.classList.add('gift-wrap-processing');
        addButton.classList.add('ajax_loading');


        /*
         * Find the product form
         */
        var form = addButton.closest('form');

        if (!form) {
            console.error('Gift Wrapping: Product form not found.');
            resetButton(addButton);
            return;
        }


        /*
         * Get selected main product variant
         */
        var variantInput = form.querySelector(
            '[name="id"], [name="variant_id"]'
        );

        var mainVariantId = variantInput
            ? variantInput.value
            : addButton.getAttribute('data-pid');

        if (!mainVariantId) {
            console.error('Gift Wrapping: Product variant ID not found.');
            resetButton(addButton);
            return;
        }


        /*
         * Get quantity
         */
        var quantityInput = form.querySelector('[name="quantity"]');

        var quantity = quantityInput
            ? parseInt(quantityInput.value, 10)
            : 1;

        if (!quantity || quantity < 1) {
            quantity = 1;
        }


        /*
         * Get Gift Wrapping variant
         */
        var giftVariantId = giftButton.getAttribute(
            'data-gift-variant-id'
        );

        if (!giftVariantId) {
            console.error('Gift Wrapping: Gift variant ID not found.');
            resetButton(addButton);
            return;
        }


        /*
         * Generate unique relationship ID.
         *
         * This prevents Shopify from merging Gift Wrapping
         * belonging to different products.
         */
        var groupId =
            'gift_' +
            Date.now() +
            '_' +
            Math.random().toString(36).substring(2, 10);


        /*
         * Get existing product properties from the form.
         */
        var properties = {};

        form.querySelectorAll(
            '[name^="properties["]'
        ).forEach(function (input) {

            var match = input.name.match(
                /^properties\[(.+)\]$/
            );

            if (!match) {
                return;
            }

            if (
                (input.type === 'checkbox' ||
                 input.type === 'radio') &&
                !input.checked
            ) {
                return;
            }

            if (input.value !== '') {
                properties[match[1]] = input.value;
            }
        });


        /*
         * Add our private relationship property
         * to the MAIN product.
         */
        properties['_gift_group'] = groupId;


        /*
         * Add both products in ONE request.
         */
        var productTitle = giftButton.getAttribute('data-product-title') || 'Product';
        var payload = {
            items: [
                {
                    id: Number(mainVariantId),
                    quantity: quantity,
                    properties: properties
                },
                {
                    id: Number(giftVariantId),
                    quantity: quantity,
                    properties: {
                        '_gift_group': groupId,
                        '_gift_addon': 'true',
                        'Gift wrapping for': productTitle
                    }
                }
            ]
        };


        fetch(
            (window.Shopify &&
             window.Shopify.routes &&
             window.Shopify.routes.root
                ? window.Shopify.routes.root
                : '/') + 'cart/add.js',
            {
                method: 'POST',

                headers: {
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest'
                },

                body: JSON.stringify(payload)
            }
        )
        .then(function (response) {

            if (!response.ok) {
                return response.json().then(function (error) {
                    throw error;
                });
            }

            return response.json();
        })
        .then(function () {

            /*
             * Reset Gift Wrapping selection
             */
            giftButton.classList.remove('is-selected');

            /*
             * Reload so the theme cart/minicart receives
             * the new grouped cart data correctly.
             */
            window.location.reload();
        })
        .catch(function (error) {

            console.error(
                'Gift Wrapping Add to Cart Error:',
                error
            );

            var message =
                error &&
                (error.description || error.message)
                    ? error.description || error.message
                    : 'Unable to add product to cart.';

            alert(message);

            resetButton(addButton);
        });


        function resetButton(button) {
            button.classList.remove('gift-wrap-processing');
            button.classList.remove('ajax_loading');
        }

    }, true);

})();